module.exports = __webpack_public_path__ + "img/dl_ewm.86c031be.png";